import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=42f5a12b&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f5a12b')) {
      api.createRecord('42f5a12b', component.options)
    } else {
      api.reload('42f5a12b', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=42f5a12b&", function () {
      api.rerender('42f5a12b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fm10JsXDBPAW/JS/comp/openstreetmap.vue"
export default component.exports